"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccess = exports.getError = exports.asDateRange = exports.asDate = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var moment_1 = __importDefault(require("moment"));
exports.asDate = (0, mobx_keystone_1.propTransform)({
    propToData: function (prop) {
        if (!prop)
            return prop;
        return (0, moment_1.default)(prop).toDate();
    },
    dataToProp: function (data) {
        if (!data)
            return data;
        return (0, moment_1.default)(data).format();
    },
});
exports.asDateRange = (0, mobx_keystone_1.propTransform)({
    propToData: function (prop) {
        if (!prop)
            return null;
        return {
            bounds: prop.bounds,
            lower: (0, moment_1.default)(prop.lower).toDate(),
            upper: (0, moment_1.default)(prop.upper).toDate(),
        };
    },
    dataToProp: function (data) {
        if (!data)
            return null;
        return {
            bounds: data.bounds,
            lower: (0, moment_1.default)(data.lower).format(),
            upper: (0, moment_1.default)(data.upper).format(),
        };
    },
});
var getError = function (error) {
    try {
        return { errors: JSON.parse(error.message), ok: false };
    }
    catch (_a) {
        return { errors: { detail: error.message }, ok: false };
    }
};
exports.getError = getError;
var _success = { errors: { detail: null }, ok: true };
var getSuccess = function () { return _success; };
exports.getSuccess = getSuccess;
